module.exports = "li {\n  padding: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/test-connection/test-connection.component.scss
// module id = 574
// module chunks = 0